(() => {
  function start(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const deadline = Date.parse(root.dataset.deadline);
    const timer = root.querySelector('[data-timer]');
    const parts = ['days','hours','minutes','seconds'].map(key => root.querySelector('[data-'+key+']'));
    const status = root.querySelector('[data-status]');
    root.querySelectorAll('model-viewer').forEach(viewer => {
      viewer.addEventListener('error', () => {
        viewer.closest('.drop__panel').querySelector('[data-status]').textContent = 'Nie udało się wczytać modelu 3D. Odśwież stronę.';
      });
    });
    let interval;
    function update() {
      if (!root.isConnected) { clearInterval(interval); return; }
      if (!Number.isFinite(deadline)) { status.textContent = 'Sprawdź datę premiery w ustawieniach szablonu.'; clearInterval(interval); return; }
      const total = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const values = [Math.floor(total/86400),Math.floor(total/3600)%24,Math.floor(total/60)%60,total%60];
      parts.forEach((part,i) => { part.textContent = String(values[i]).padStart(2,'0'); });
      timer.setAttribute('aria-label', `${values[0]} days, ${values[1]} hours, ${values[2]} minutes, ${values[3]} seconds`);
      if (!total) clearInterval(interval);
    }
    interval = setInterval(update,250); update();
  }
  function init(scope) { scope.querySelectorAll('[data-drop]').forEach(start); }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();